/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateProduct = /* GraphQL */ `
  subscription OnCreateProduct {
    onCreateProduct {
      id
      code
      description
      cost
      price
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateProduct = /* GraphQL */ `
  subscription OnUpdateProduct {
    onUpdateProduct {
      id
      code
      description
      cost
      price
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteProduct = /* GraphQL */ `
  subscription OnDeleteProduct {
    onDeleteProduct {
      id
      code
      description
      cost
      price
      createdAt
      updatedAt
    }
  }
`;
export const onCreatePharmacy = /* GraphQL */ `
  subscription OnCreatePharmacy {
    onCreatePharmacy {
      id
      code
      description
      enabled
      createdAt
      updatedAt
    }
  }
`;
export const onUpdatePharmacy = /* GraphQL */ `
  subscription OnUpdatePharmacy {
    onUpdatePharmacy {
      id
      code
      description
      enabled
      createdAt
      updatedAt
    }
  }
`;
export const onDeletePharmacy = /* GraphQL */ `
  subscription OnDeletePharmacy {
    onDeletePharmacy {
      id
      code
      description
      enabled
      createdAt
      updatedAt
    }
  }
`;
export const onCreateCustomer = /* GraphQL */ `
  subscription OnCreateCustomer {
    onCreateCustomer {
      id
      customerId
      name
      contactName
      chargeTo
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateCustomer = /* GraphQL */ `
  subscription OnUpdateCustomer {
    onUpdateCustomer {
      id
      customerId
      name
      contactName
      chargeTo
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteCustomer = /* GraphQL */ `
  subscription OnDeleteCustomer {
    onDeleteCustomer {
      id
      customerId
      name
      contactName
      chargeTo
      createdAt
      updatedAt
    }
  }
`;
export const onCreateContract = /* GraphQL */ `
  subscription OnCreateContract {
    onCreateContract {
      id
      voucherCode
      voucherExpiry
      customerId
      productId
      customer {
        id
        customerId
        name
        contactName
        chargeTo
        createdAt
        updatedAt
      }
      product {
        id
        code
        description
        cost
        price
        createdAt
        updatedAt
      }
      customerAttributes {
        name
        multiList
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateContract = /* GraphQL */ `
  subscription OnUpdateContract {
    onUpdateContract {
      id
      voucherCode
      voucherExpiry
      customerId
      productId
      customer {
        id
        customerId
        name
        contactName
        chargeTo
        createdAt
        updatedAt
      }
      product {
        id
        code
        description
        cost
        price
        createdAt
        updatedAt
      }
      customerAttributes {
        name
        multiList
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteContract = /* GraphQL */ `
  subscription OnDeleteContract {
    onDeleteContract {
      id
      voucherCode
      voucherExpiry
      customerId
      productId
      customer {
        id
        customerId
        name
        contactName
        chargeTo
        createdAt
        updatedAt
      }
      product {
        id
        code
        description
        cost
        price
        createdAt
        updatedAt
      }
      customerAttributes {
        name
        multiList
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateAdditionalItem = /* GraphQL */ `
  subscription OnCreateAdditionalItem {
    onCreateAdditionalItem {
      id
      contractId
      label
      values
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateAdditionalItem = /* GraphQL */ `
  subscription OnUpdateAdditionalItem {
    onUpdateAdditionalItem {
      id
      contractId
      label
      values
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteAdditionalItem = /* GraphQL */ `
  subscription OnDeleteAdditionalItem {
    onDeleteAdditionalItem {
      id
      contractId
      label
      values
      createdAt
      updatedAt
    }
  }
`;
export const onCreateVaccination = /* GraphQL */ `
  subscription OnCreateVaccination {
    onCreateVaccination {
      id
      pharmacyCode
      chargeTo
      voucherCode
      contractId
      contract {
        id
        voucherCode
        voucherExpiry
        customerId
        productId
        customer {
          id
          customerId
          name
          contactName
          chargeTo
          createdAt
          updatedAt
        }
        product {
          id
          code
          description
          cost
          price
          createdAt
          updatedAt
        }
        customerAttributes {
          name
          multiList
        }
        createdAt
        updatedAt
      }
      vaccinationDate
      patientName
      customerAttributes {
        name
        value
      }
      lastUpdatedBy
      vaccinationYearMonth
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateVaccination = /* GraphQL */ `
  subscription OnUpdateVaccination {
    onUpdateVaccination {
      id
      pharmacyCode
      chargeTo
      voucherCode
      contractId
      contract {
        id
        voucherCode
        voucherExpiry
        customerId
        productId
        customer {
          id
          customerId
          name
          contactName
          chargeTo
          createdAt
          updatedAt
        }
        product {
          id
          code
          description
          cost
          price
          createdAt
          updatedAt
        }
        customerAttributes {
          name
          multiList
        }
        createdAt
        updatedAt
      }
      vaccinationDate
      patientName
      customerAttributes {
        name
        value
      }
      lastUpdatedBy
      vaccinationYearMonth
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteVaccination = /* GraphQL */ `
  subscription OnDeleteVaccination {
    onDeleteVaccination {
      id
      pharmacyCode
      chargeTo
      voucherCode
      contractId
      contract {
        id
        voucherCode
        voucherExpiry
        customerId
        productId
        customer {
          id
          customerId
          name
          contactName
          chargeTo
          createdAt
          updatedAt
        }
        product {
          id
          code
          description
          cost
          price
          createdAt
          updatedAt
        }
        customerAttributes {
          name
          multiList
        }
        createdAt
        updatedAt
      }
      vaccinationDate
      patientName
      customerAttributes {
        name
        value
      }
      lastUpdatedBy
      vaccinationYearMonth
      createdAt
      updatedAt
    }
  }
`;
export const onCreatePharmacyUser = /* GraphQL */ `
  subscription OnCreatePharmacyUser {
    onCreatePharmacyUser {
      id
      userEmail
      pharmacyCodes
      enabled
      createdAt
      updatedAt
    }
  }
`;
export const onUpdatePharmacyUser = /* GraphQL */ `
  subscription OnUpdatePharmacyUser {
    onUpdatePharmacyUser {
      id
      userEmail
      pharmacyCodes
      enabled
      createdAt
      updatedAt
    }
  }
`;
export const onDeletePharmacyUser = /* GraphQL */ `
  subscription OnDeletePharmacyUser {
    onDeletePharmacyUser {
      id
      userEmail
      pharmacyCodes
      enabled
      createdAt
      updatedAt
    }
  }
`;
